import $ from "jquery";

// $(".js-show-more").on("click", function (e) {
// 	e.preventDefault();

// 	$(this)
// 		.closest(".js-checkboxes")
// 		.find(".checkboxes li.is-hidden")
// 		.slideToggle();
// 	$(this).find("img").toggleClass("rotate");
// });

$(".js-checkboxes-title").on("click", function () {
	$(this).toggleClass("is-active");
	$(this).next().slideToggle();
});

$(".js-filter-btn").on("click", function (e) {
	e.preventDefault();

	$(".js-filters").addClass("filter-is-visible");
});

$(".js-filters-close-btn").on("click", function (e) {
	e.preventDefault();

	$(".js-filters").removeClass("filter-is-visible");
});

/**
 * Filter functions
 */
$(".js-checkbox").on("change", (e) => {
	$(".js-filter").submit();
});

function removeQueryParamAndReload(param) {
	var url = new URL(window.location.href);
	var searchParams = new URLSearchParams(url.search);

	// Remove the query parameter
	if (searchParams.has(param)) {
		searchParams.delete(param);
		url.search = searchParams.toString();
	}
}

/**
 * Remove filters
 */
document.addEventListener("DOMContentLoaded", function () {
	var resetButtons = document.querySelectorAll(".js-reset-filters");
	// Loop through each button and add the event listener
	resetButtons.forEach(function (button) {
		button.addEventListener("click", function () {
			var parentUrl = this.getAttribute("data-parent"); // Get the URL from the data-parent attribute
			window.location.href = parentUrl; // Navigate to the URL retrieved from data-parent
		});
	});

	var btnResetMerken = document.querySelectorAll(".js-reset-merken");

	btnResetMerken.forEach(function (button) {
		button.addEventListener("click", function () {
			// Call the custom function to remove the 'merk' parameter and reload
			removeQueryParamAndReload("merk");
		});
	});
});
